import { Injectable } from '@angular/core';
import { AtpHttpErrorsService, AtpHttpErrorsServicePopupType } from '../atp-core/services/atp-http-errors.service';
import { HttpService } from './http.service';
import { Location } from '@angular/common';
import { AuthService } from './auth.service';
import { MatDialogConfig } from '@angular/material/dialog';

// @AtpHttpErrorsServicePopupType()
@Injectable({
  providedIn: 'root'
})
export class HttpErrorsService extends AtpHttpErrorsService {

  constructor(api: HttpService, location: Location, private _authService: AuthService) {
    super(api, location)
  }

  protected dialogActionData: MatDialogConfig<any> = { width: '450px' };

  moveToAuth(): void {
    this._authService.openPopup();
  }
}
